module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-visible-on-d91d0ed6059e233057111a8699e709b6.png";